export enum SettingsTimeOffDataEventObjectsEnum {
  TIME_OFF_EDIT = 'time_off_edit',
  TIME_OFF_CREATE = 'time_off_create',
  TIME_OFF_EDIT_SAVE = 'time_off_edit_save',
}
